module.exports = __webpack_public_path__ + "img/Color 092.9eb655b3.jpg";